import { useRef } from 'react';

const BUBBLE_COLORS = ['#DDB0CB', '#D99B87', '#96C7FF', '#F0D600', '#9CCDE2', '#E798BF', '#C6E593', '#E2E2E2'];
type ColorsMap = Record<string, string>;

export const useBubbleColors = () => {
  const userColorMap = useRef<ColorsMap>({});
  const lastBubbleColorIndex = useRef<number>(0);

  const getNextIndex = () => {
    return (lastBubbleColorIndex.current + 1) % BUBBLE_COLORS.length;
  };

  const getUserColor = (userId: string) => {
    const hasColor = userColorMap.current[userId];
    if (!hasColor) {
      const nextIndex = getNextIndex();
      userColorMap.current[userId] = BUBBLE_COLORS[nextIndex];
      lastBubbleColorIndex.current = nextIndex;
    }

    const response = userColorMap.current[userId];
    return response;
  };

  return {
    getUserColor,
  };
};
